<template>
  <el-menu class="navbar nb-bar" mode="horizontal">
    <!--<hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>-->

    <breadcrumb class="breadcrumb-container"></breadcrumb>

    <!--<div class="right-menu">-->
      <!--<error-log class="errLog-container right-menu-item"></error-log>-->

      <!--<el-tooltip effect="dark" :content="$t('navbar.screenfull')" placement="bottom">-->
        <!--<screenfull class="screenfull right-menu-item"></screenfull>-->
      <!--</el-tooltip>-->

      <!--<lang-select class="international right-menu-item"></lang-select>-->

      <!--<el-tooltip effect="dark" :content="$t('navbar.theme')" placement="bottom">-->
        <!--<theme-picker class="theme-switch right-menu-item"></theme-picker>-->
      <!--</el-tooltip>-->

      <!--<el-dropdown class="avatar-container right-menu-item" trigger="click">-->
        <!--<div class="avatar-wrapper">-->
          <!--<img class="user-avatar" :src="avatar+'?imageView2/1/w/80/h/80'">-->
          <!--<i class="el-icon-caret-bottom"></i>-->
        <!--</div>-->
        <!--<el-dropdown-menu slot="dropdown">-->
          <!--<router-link to="/">-->
            <!--<el-dropdown-item>-->
              <!--{{$t('navbar.dashboard')}}-->
            <!--</el-dropdown-item>-->
          <!--</router-link>-->
          <!--<a target='_blank' href="https://github.com/PanJiaChen/vue-element-admin/">-->
            <!--<el-dropdown-item>-->
              <!--{{$t('navbar.github')}}-->
            <!--</el-dropdown-item>-->
          <!--</a>-->
          <!--<el-dropdown-item divided>-->
            <!--<span @click="logout" style="display:block;">{{$t('navbar.logOut')}}</span>-->
          <!--</el-dropdown-item>-->
        <!--</el-dropdown-menu>-->
      <!--</el-dropdown>-->
    <!--</div>-->
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import LangSelect from '@/components/LangSelect'
// import ThemePicker from '@/components/ThemePicker'

export default {
  data() {
    let _this = this
    return {
      avatarImg: _this.$store.state.user.avatar,
    }
  },
  components: {
    Breadcrumb,
    Hamburger,
    // ErrorLog,
    // Screenfull,
    // LangSelect,
    // ThemePicker
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },

  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.nb-bar{
  height: 40px;
  line-height: 40px;
  border-radius: 0px !important;
  background:rgba(0, 0, 0, 0.25);
  .app-breadcrumb.el-breadcrumb{
    line-height: 40px !important;
  }
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container{
    float: left;
    margin-left: 20px !important;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .el-breadcrumb__inner,
  .el-breadcrumb__separator,
  .no-redirect{
    color: rgba(0, 0, 0, 0.65) !important;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue